'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var and = {};

exports.__exports = and;
